import type { MotionSkin } from "./types";

export const football2026Skin: MotionSkin = {
  id: "football2026",
  label: "W杯2026",
  season: "football",
  palette: {
    backgroundTop: "#143b7c",
    backgroundBottom: "#1d9654",
    foreground: "#f8fbff",
    muted: "#c7d7ef",
    up: "#28e082",
    down: "#ff5968",
    grid: "rgba(226,240,255,.18)",
    card: "rgba(8,28,68,.74)",
    panel: "rgba(10,33,78,.72)",
    accent: "#f53346"
  },
  typography: { family: "system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif", titleWeight: 850 },
  decoration: "football",
  upEffect: "goal",
  downEffect: "miss",
  assetSlots: {
    background: "/skins/football2026/background.png",
    tipIdle: "/skins/football2026/tipIdle.png",
    tipUp: "/skins/football2026/tipUp.png",
    tipDown: "/skins/football2026/tipDown.png",
    accentUp: "/skins/football2026/accentUp.png",
    accentDown: "/skins/football2026/accentDown.png"
  }
};
